import Swiper, {Navigation, Pagination, FreeMode, Manipulation} from 'swiper';

Swiper.use([Navigation, Pagination, FreeMode, Manipulation]);

export const slider = () => {
  const slider = document.querySelector('.swiper-history')
  const prev = document.querySelector('.arrow-prev');
  const next = document.querySelector('.arrow-next');
  const sliderArrow = slider.querySelectorAll('.arrows');
  sliderArrow.forEach((el) => {
    const left= el.querySelector('.left');
    const right= el.querySelector('.right');
    left.addEventListener('click', () => {
      prev.click();
    })
    right.addEventListener('click', () => {
      next.click();
    })
  })
  const swiper = new Swiper(slider, {
    // loop: true,
    freeMode: true,
    spaceBetween: 8,
    slidesPerView: 'auto',

    navigation: {
      nextEl: next,
      prevEl: prev,
    },

    breakpoints: {

      0: {
        spaceBetween: 8,
        slidesPerView: 1,
      },
      667: {
        spaceBetween: 20,
        slidesPerView: 1,
      },

    }
  });


}
